import {Component, Input, OnInit} from '@angular/core';
import {ConfService} from '../conf.service';

@Component({
  selector: 'app-api-response-settings',
  templateUrl: './api-response-settings.component.html',
  styleUrls: ['./api-response-settings.component.scss']
})
export class ApiResponseSettingsComponent implements OnInit {
  settings = {
    text: 'Select Content Types *',
    // selectAllText: 'Select All',
    // unSelectAllText: 'Unselect All',
    enableSearchFilter: true,
    autoPosition: false
  };

  getStatusCodes = [];
  postStatusCodes = [];
  putStatusCodes = [];
  deleteStatusCodes = [];
  patchStatusCodes = [];
  statusCodes = [];
  @Input() apiResponse: any;
  @Input() selectedDatatypeFilter: any;
  contentTypeArray = [];
  // contentTypes = [
  //     {'itemName': 'application/java-archive', 'id': 'application/java-archive'},
  //   {'itemName': 'application/EDI-X12', 'id': 'application/EDI-X12'},
  //   {'itemName': 'application/EDIFACT', 'id': 'application/EDIFACT'},
  //   {'itemName': 'application/javascript', 'id': 'application/javascript'},
  //   {'itemName': 'application/octet-stream', 'id': 'application/octet-stream'},
  //   {'itemName': 'application/ogg', 'id': 'application/ogg'},
  //   {'itemName': 'application/pdf', 'id': 'application/pdf'},
  //   {'itemName': 'application/xhtml+xml', 'id': 'application/xhtml+xml'},
  //   {'itemName': 'application/x-shockwave-flash', 'id': 'application/x-shockwave-flash'},
  //   {'itemName': 'application/json', 'id': 'application/json'},
  //   {'itemName': 'application/ld+json', 'id': 'application/ld+json'},
  //   {'itemName': 'application/xml', 'id': 'application/xml'},
  //   {'itemName': 'application/zip', 'id': 'application/zip'},
  //   {'itemName': 'application/x-www-form-urlencoded', 'id': 'application/x-www-form-urlencoded'},
  //
  //   {'itemName': 'audio/mpeg', 'id': 'audio/mpeg'},
  //   {'itemName': 'audio/x-ms-wma', 'id': 'audio/x-ms-wma'},
  //   {'itemName': 'audio/vnd.rn-realaudio', 'id': 'audio/vnd.rn-realaudio'},
  //   {'itemName': 'audio/x-wav', 'id': 'audio/x-wav'},
  //
  //   {'itemName': 'image/gif', 'id': 'image/gif'},
  //   {'itemName': 'image/jpeg', 'id': 'image/jpeg'},
  //   {'itemName': 'image/png', 'id': 'image/png'},
  //   {'itemName': 'image/tiff', 'id': 'image/tiff'},
  //   {'itemName': 'image/vnd.microsoft.icon', 'id': 'image/vnd.microsoft.icon'},
  //   {'itemName': 'image/x-icon', 'id': 'image/x-icon'},
  //   {'itemName': 'image/vnd.djvu', 'id': 'image/vnd.djvu'},
  //   {'itemName': 'image/svg+xml', 'id': 'image/svg+xml'},
  //
  //   {'itemName': 'multipart/mixed', 'id': 'multipart/mixed'},
  //   {'itemName': 'multipart/alternative', 'id': 'multipart/alternative'},
  //   {'itemName': 'multipart/related', 'id': 'multipart/related'},
  //   {'itemName': 'multipart/mixed', 'id': 'multipart/form-data'},
  //
  //   {'itemName': 'text/css', 'id': 'text/css'},
  //   {'itemName': 'text/csv', 'id': 'text/csv'},
  //   {'itemName': 'text/html', 'id': 'text/html'},
  //   {'itemName': 'text/javascript', 'id': 'text/javascript'},
  //   {'itemName': 'text/plain', 'id': 'text/plain'},
  //   {'itemName': 'text/xml', 'id': 'text/xml'},
  //
  //   {'itemName': 'video/mpeg', 'id': 'video/mpeg'},
  //   {'itemName': 'video/mp4', 'id': 'video/mp4'},
  //   {'itemName': 'video/quicktime', 'id': 'video/quicktime'},
  //   {'itemName': 'video/x-ms-wmv', 'id': 'video/x-ms-wmv'},
  //   {'itemName': 'video/x-msvideo', 'id': 'video/x-msvideo'},
  //   {'itemName': 'video/x-flv', 'id': 'video/x-flv'},
  //   {'itemName': 'video/webm', 'id': 'video/webm'},
  //
  //
  //   {'itemName': 'application/vnd.android.package-archive', 'id': 'application/vnd.android.package-archive'},
  //   {'itemName': 'application/vnd.oasis.opendocument.text', 'id': 'application/vnd.oasis.opendocument.text'},
  //   {'itemName': 'application/vnd.oasis.opendocument.spreadsheet', 'id': 'application/vnd.oasis.opendocument.spreadsheet'},
  //   {'itemName': 'application/vnd.oasis.opendocument.presentation', 'id': 'application/vnd.oasis.opendocument.presentation'},
  //   {'itemName': 'application/vnd.oasis.opendocument.graphics', 'id': 'application/vnd.oasis.opendocument.graphics'},
  //   {'itemName': 'application/vnd.ms-excel', 'id': 'application/vnd.ms-excel'},
  //   {'itemName': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'id': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'},
  //   {'itemName': 'application/vnd.ms-powerpoint', 'id': 'application/vnd.ms-powerpoint'},
  //   {'itemName': 'application/vnd.openxmlformats-officedocument.presentationml.presentation', 'id': 'application/vnd.openxmlformats-officedocument.presentationml.presentation'},
  //   {'itemName': 'application/vnd.msword', 'id': 'application/vnd.msword'},
  //   {'itemName': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'id': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'},
  //   {'itemName': 'application/vnd.mozilla.xul+xml', 'id': 'application/vnd.mozilla.xul+xml'}
  //   ];

    contentTypes = [
        {'itemName': 'application/json', 'id': 'application/json'}
    ];

  constructor(public confPost: ConfService) { }

  populateAPIResponseContent() {
      this.apiResponse['content'] = [];
      this.contentTypeArray.forEach(contentTypeObject => {
          if (contentTypeObject && contentTypeObject !== null && contentTypeObject !== undefined) {
              this.apiResponse['content'].push({'content-type': contentTypeObject['id'], type: 'array', description: ''});
          }
      });
  }

  addNewContent() {
      this.apiResponse.apiResponseDetails.push({statusCode: null, message: '', description: ''});
  }

  removeContent(data, index) {
      data.splice(index, 1);
  }

  ngOnInit() {
      // this.addNewContent();
      if (this.apiResponse['apiResponseDetails'] && this.apiResponse['apiResponseDetails'].length === 0) {
          this.confPost.getDefaultAPIResponse(localStorage.getItem('partner'), localStorage.getItem('account'), this.apiResponse['method']).subscribe(response => {
              // this.apiResponse['apiResponseDetails'] = response['apiResponseDetails'];
              this.statusCodes = response['apiResponseDetails'];
              // if (this.apiResponse.method === 'GET') {
              //     this.getStatusCodes = response['apiResponseDetails'];
              // } else if (this.apiResponse.method === 'POST') {
              //     this.postStatusCodes = response['apiResponseDetails'];
              // } else if (this.apiResponse.method === 'PUT') {
              //     this.putStatusCodes = response['apiResponseDetails'];
              // } else if (this.apiResponse.method === 'PATCH') {
              //     this.patchStatusCodes = response['apiResponseDetails'];
              // } else if (this.apiResponse.method === 'DELETE') {
              //     this.deleteStatusCodes = response['apiResponseDetails'];
              // }
          });
      } else {
          this.statusCodes = this.apiResponse['apiResponseDetails'];
      }
      // else {
      //     if (this.apiResponse.method === 'GET') {
      //         this.getStatusCodes = this.apiResponse['apiResponseDetails'];
      //     } else if (this.apiResponse.method === 'POST') {
      //         this.postStatusCodes = this.apiResponse['apiResponseDetails'];
      //     } else if (this.apiResponse.method === 'PUT') {
      //         this.putStatusCodes = this.apiResponse['apiResponseDetails'];
      //     } else if (this.apiResponse.method === 'PATCH') {
      //         this.patchStatusCodes = this.apiResponse['apiResponseDetails'];
      //     } else if (this.apiResponse.method === 'DELETE') {
      //         this.deleteStatusCodes = this.apiResponse['apiResponseDetails'];
      //     }
      // }

      if (this.apiResponse['method'] === 'GET' && this.apiResponse['content'] && this.apiResponse['content'].length === 0) {
          this.confPost.getDefaultAPIResponse(localStorage.getItem('partner'), localStorage.getItem('account'), this.apiResponse['method']).subscribe(response => {
              this.apiResponse['content'] = response['content'];
              this.apiResponse['content'].forEach((contentType) => {
                  if (contentType && contentType !== null && contentType !== undefined && contentType['content-type'] && contentType['content-type'] !== null && contentType['content-type'] !== undefined && contentType['content-type'] !== '') {
                      this.contentTypeArray.push({id: contentType['content-type'], itemName: contentType['content-type']});
                  }
              });
          });
      } else if (this.apiResponse['method'] === 'GET' && this.apiResponse['content'].length > 0) {
          this.apiResponse['content'].forEach((contentType) => {
              if (contentType && contentType !== null && contentType !== undefined && contentType['content-type'] && contentType['content-type'] !== null && contentType['content-type'] !== undefined && contentType['content-type'] !== '') {
                  this.contentTypeArray.push({id: contentType['content-type'], itemName: contentType['content-type']});
              }
          });
      }
  }

}
